<ng-template #headerAddAction>
  <button
    type="button"
    class="cabinet-client-page__add-button"
    (click)="onAdd()"
  >
    + {{ 'admin.warehouses.add' | translate }}
  </button>
</ng-template>

<div class="admin-warehouses core-screen">
  @if (!embeddedInCabinetPage()) {
  <div class="title-bar">
    <div class="title-section">
      <h1 class="core-title">{{ 'admin.warehouses.title' | translate }}</h1>
      @if (displayCount() !== null) {
      <span class="count">{{ displayCount() }}</span>
      }
    </div>
    @if (initialized()) {
    <button class="add-button" (click)="onAdd()">
      + {{ 'admin.warehouses.add' | translate }}
    </button>
    }
  </div>
  }

  @if (initialized()) {
  <div class="search-bar">
    <lib-not-input
      type="text"
      [placeholder]="'admin.warehouses.search' | translate"
      [ngModel]="searchQuery()"
      (ngModelChange)="onSearchChange($event)"
      [hideErrorBlock]="true"
    />
  </div>
  }

  <div class="warehouses-list">
    @if (warehouses()?.warehouses && warehouses()!.warehouses.length > 0) { @for
    (warehouse of warehouses()!.warehouses; track warehouse.id) {
    <div
      class="warehouse-card"
      [class.deactivated]="!isActive(warehouse)"
      (click)="onView(warehouse)"
    >
      <div class="card-header">
        <div class="avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 21V8l9-5 9 5v13"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 21V12h6v9"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="warehouse-info">
          <div class="name-row">
            <div class="name">{{ warehouse.name }}</div>
            @if (!isActive(warehouse)) {
            <span class="deactivated-badge"
              >{{ 'admin.warehouses.deactivated' | translate }}</span
            >
            }
          </div>
          <div class="city">{{ warehouse.city }}, {{warehouse.address}}</div>
        </div>
      </div>

      <div class="card-actions">
        @if (warehouse.phone) {
        <a
          class="action-button"
          [href]="'tel:' + warehouse.phone"
          (click)="$event.stopPropagation()"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        } @if (hasCoordinates(warehouse)) {
        <a
          class="action-button"
          [href]="getYandexMapsUrl(warehouse)"
          (click)="$event.stopPropagation()"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 10.5L20.25 3l-7.5 17.25-2.625-7.125L3 10.5z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.125 13.125L20.25 3"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        }
      </div>
    </div>
    } } @else if ( !loading() && initialized() &&
    (warehouses()?.warehouses?.length ?? 0) === 0 && searchQuery() ) {
    <div class="warehouses-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.warehouses.notFound' | translate }}</p>
        <p class="empty-hint">
          {{ 'admin.warehouses.notFoundHint' | translate }}
        </p>
      </div>
      <span>&nbsp;</span>
    </div>
    } @else if ( !loading() && initialized() &&
    (warehouses()?.warehouses?.length ?? 0) === 0 ) {
    <div class="warehouses-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.warehouses.empty' | translate }}</p>
        <p class="empty-hint">{{ 'admin.warehouses.emptyHint' | translate }}</p>
      </div>
      <lib-cabinet-button
        class="empty-button"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="'admin.warehouses.add' | translate"
        [action]="{type: 'action'}"
        (actionEvent)="onAdd()"
      />
    </div>
    } @else if (loading()) {
    <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    }
  </div>
</div>
